import pLimit from 'p-limit'

// eslint-disable-next-line import/prefer-default-export
export function loadImg(url) {
  return new Promise((resolve, reject) => {
    const img = new Image()

    img.src = url

    img.onload = resolve
    img.onerror = reject
  })
}

export function sleep(times) {
  return new Promise(resolve => {
    setTimeout(resolve, times)
  })
}

export async function limitLoad(urls, handler, limit) {
  const generator = pLimit(limit)
  const fns = urls.map(x => generator(() => handler(x)))

  await sleep(1000)

  return Promise.all(fns)
}

export function timer(timeout = 0) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, timeout)
  })
}
